import React from 'react'
import './index.less'
import {Button, Col, Input, message, Modal, Radio, Row, Table, Tabs, TimePicker, Upload, ConfigProvider} from "antd";
import {
    API_IMG_UPLOAD,
    API_HOST_WEBSOCKET
} from "../../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import ImgCrop from "antd-img-crop";
import { Map, Marker } from 'react-amap';
import NoticeEmitter from "../../../utils/NoticeUtil";
import {
    getTemplateInfo,
    getTemplateListShop,
    getTemplateUpdateOpentime,
    getTemplateUpdatePromotion,
    getTemplateUpdateDescription,
    getTemplateUpdateInvoice,
    getTemplateSynchronization,
    getShopInfo,
    getShopUpdateLogo,
    getShopUpdateName,
    getShopUpdatePhone,
    getShopUpdateAddress,
    getShopUpdateOpentime,
    getShopUpdatePromotion,
    getShopUpdateDescription,
    getShopUpdateInvoice,
    getTemplateUpdatePhone,
    getTemplateSynchronizationPhone
} from "../../../constants/api";
import {removeToken} from "../../../utils/cookie";

import zhCN from "antd/es/locale/zh_CN";
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const { TabPane } = Tabs;
const RadioGroup = Radio.Group;
const axiosD = require('axios').default;
export default class ShopMessage extends React.Component {

    constructor() {
        super();
        this.connectWebSocket();

        NoticeEmitter.addListener('SHOPID_KEY', (value) => {
            console.log('门店信息=====================================' + value)
            this.setState({shopId: value})
            if (value == 0) {
                this.searchTemplateInfo(this.state.templateId)
            } else {
                this.searchShopInfo(value);
            }
        })
    }

    state = {
        platformType: null,//平台类型
        templateId: 0,//模板ID
        shopId: 0,//门店ID
        shop: [],//门店数据

        showImg: true, //图片
        previewVisible: false,
        previewImage: '',
        fileList: [],
        imageUrl: '',
        imageHash: '',

        inputShopName: '',//门店名称
        inputTel: '',//门店电话
        inputTelIvr: '',//订单提醒电话
        inputTelService: '',//客服电话
        inputAddress: '',//门店地址信息
        timeInterval: 1,//营业时间选择默认
        openTime: '',//营业时间
        inputShopNotice: '',//门店公告
        inputShopDesc: '',//门店简介
        invoice: 0,//是否提供发票
        inputInvoice: '',//发票金额

        onMapVisible: false,//修改地址弹窗
        addressGeo: '',//门店地址经纬度
        lat: 0,
        long: 0,

        //总店
        timeIntervalMain: 1,
        inputShopNoticeMain: '',
        inputShopDescMain: '',//门店简介
        invoiceMain: 0,//是否提供发票
        inputInvoiceMain: '',//发票金额
        showAllModal: false,  //同步至分店的modal
        selectedRowKeysSync: [],
        loadingAll: false,
        syncMsg: '',//同步的是哪一个

        inputTelMain: '',//门店电话
        inputTelIvrMain: '',//订单提醒电话
        inputTelServiceMain: '',//客服电话

        openTimeStart: '',
        openTimeEnd: '',
        openTimeStart2: '',
        openTimeEnd2: '',

        showSyncPhoneModal: false,//总店电话同步
        phoneType: 0,
        loadingAll2: false,
    }

    connectWebSocket() {
        const _this = this;
        let websocket, lockReconnect = false;
        this.createWebSocket = (url) => {
            websocket = new WebSocket(url);
            websocket.onopen = function () {
                heartCheck.reset().start();
            }
            websocket.onerror = function () {
                reconnect(url);
            };
            websocket.onclose = function (e) {
                console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
            }
            websocket.onmessage = function (event) {
                // console.log(event.data)
                if (event.data === '连接成功') {
                    // lockReconnect = true;
                    // _this.setState({
                    //     loadingAll: false,
                    // })
                } else {
                    let data = JSON.parse(event.data)
                    lockReconnect = true;
                    //event 为服务端传输的消息，在这里可以处理
                    if (data.dataHandleStatus === 1) {
                        message.success('同步成功')
                        _this.setState({
                            loadingAll: false,
                            showAllModal: false,
                            loadingAll2: false,
                            showSyncPhoneModal: false
                        })
                    }
                }

            }
        }
        let reconnect = (url) => {
            if (lockReconnect) return;
            //没连接上会一直重连，设置延迟避免请求过多
            setTimeout(function () {
                this.createWebSocket(url);
                lockReconnect = false;
            }, 4000);
        }
        let heartCheck = {
            timeout: 60000, //60秒
            timeoutObj: null,
            reset: function () {
                clearInterval(this.timeoutObj);
                return this;
            },
            start: function () {
                this.timeoutObj = setInterval(function () {
                    //这里发送一个心跳，后端收到后，返回一个心跳消息，
                    //onmessage拿到返回的心跳就说明连接正常
                    websocket.send("HeartBeat");
                }, this.timeout)
            }
        }
        //关闭连接
        this.closeWebSocket = () => {
            websocket && websocket.close();
        }
    }

    componentDidMount() {
        this.getTemplateId()
    }
    getTemplateId = () => {
        let storage = window.localStorage;
        let templateId = storage.getItem('templateId');
        let shopId = storage.getItem('shopId');
        let platformType = storage.getItem('platformType');
        if (templateId) {
            this.setState({
                templateId: templateId,
                platformType: platformType,
                shopId: shopId
            }, () => {
                this.searchShop();
                if (shopId == 0) {
                    this.searchTemplateInfo(templateId)
                } else {
                    this.searchShopInfo(shopId);
                }
            })
        } else {
            message.error('请先选择总店', 1)
        }
    }

    searchTemplateInfo = (templateId) => {
        const _this = this;
        getTemplateInfo({
            id: templateId,
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    _this.setState({
                        // inputShopName: data.data.branchShopName,
                        inputTelMain: data.data.phone,
                        inputTelIvrMain: data.data.ivrPhone,
                        inputTelServiceMain: data.data.servicePhone,
                        // inputAddress: data.data.address,
                        // addressGeo: data.data.addressGeo,
                        // imageUrl: data.data.imageUrl,
                        // imageHash: data.data.imageHash,
                        inputShopNoticeMain: data.data.promotion,
                        // openTime: data.data.openTime,
                        inputShopDescMain: data.data.shopDescription,
                        invoiceMain:data.data.invoice,
                        inputInvoiceMain: data.data.invoiceMinAmount,
                    });
                    if (data.data.openTime && data.data.openTime != null) {
                        if (data.data.openTime === '00:00-23:59') {
                            _this.setState({timeIntervalMain: 1})
                        } else {
                            if (data.data.openTime == '') {

                            } else {
                                let openTimeArr = data.data.openTime.split('-')
                                _this.setState({
                                    timeIntervalMain: 2,
                                    openTimeStart: openTimeArr[0],
                                    openTimeEnd: openTimeArr[1],
                                })
                            }
                        }
                    }
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    //查询门店列表，用于切换门店
    searchShop() {
        const _this = this;
        getTemplateListShop({
            id: this.state.templateId,
            searchStr: "",
            shopId: 0,
            templateId: this.state.templateId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    _this.setState({
                        shop: data.data,
                    });
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })

        // axiosD.post(API_GOODS_SEARCH_SHOP, {
        //     id: this.state.templateId,
        //     searchStr: "",
        //     shopId: 0,
        //     templateId: this.state.templateId
        // })
        //     .then(function (response) {
        //         let data = response.data;
        //         console.log(data)
        //         _this.setState({
        //             shop: data.data,
        //         });
        //     })
        //     .catch(function (error) {
        //         console.log(error);
        //     });
    }
    //切换门店
    changeShop = value => {
        console.log(value)
        this.setState({shopId: value})
        if (value == 0) {
            this.searchTemplateInfo(this.state.templateId)
        } else {
            this.searchShopInfo(value);
        }
    };
    searchShopInfo = (shopid) => {
        const _this = this;
        getShopInfo({
            id: shopid,
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    _this.setState({
                        inputShopName: data.data.branchShopName,
                        inputTel: data.data.phone,
                        inputTelIvr: data.data.ivrPhone,
                        inputTelService: data.data.servicePhone,
                        inputAddress: data.data.address,
                        addressGeo: data.data.addressGeo,
                        imageUrl: data.data.imageUrl,
                        imageHash: data.data.imageHash,
                        inputShopNotice: data.data.promotion,
                        openTime: data.data.openTime,
                        inputShopDesc: data.data.description,
                        invoice:data.data.invoice,
                        inputInvoice: data.data.invoiceMinAmount,
                    });
                    if (data.data.openTime === '00:00-23:59') {
                        _this.setState({timeInterval: 1})
                    } else {
                        // _this.setState({timeInterval: 2})
                        if (data.data.openTime == '') {

                        } else {
                            let openTimeArr = data.data.openTime.split('-')
                            _this.setState({
                                timeInterval: 2,
                                openTimeStart2: openTimeArr[0],
                                openTimeEnd2: openTimeArr[1],
                            })
                        }
                    }
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    searchLatlngByAddress = (address) =>{
        const _this = this;
        let key = 'e73ee0f829ee336137ca9eabdee6382e';
        axiosD.get('https://restapi.amap.com/v3/geocode/geo?key=' + key + '&address=' + address, {
        })
            .then(function (response) {
                console.log(response.data)
                let code = response.data.status;
                if (code == '1') {
                    if (response.data.geocodes.length > 0) {
                        let location = response.data.geocodes[0].location
                        let locationArry = location.split(',');
                        let long = locationArry[0];
                        let lat = locationArry[1];
                        _this.setState({
                            addressGeo: response.data.geocodes[0].location,
                            long: long,
                            lat: lat
                        });
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    callback(key) {
        console.log(key);
    }

    updateLogo(imageHash, imageUrl) {
        getShopUpdateLogo({
            imageHash: imageHash,
            imageUrl: imageUrl,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })

        // axiosD.post(API_SHOP_UPDATE_LOGO, {
        //     imageHash: imageHash,
        //     imageUrl: imageUrl,
        //     shopId: this.state.shopId
        // })
        //     .then(function (response) {
        //         let data = response.data;
        //         console.log(data)
        //         if (data.code === 0) {
        //             message.success(data.msg)
        //         } else {
        //             message.error(data.msg)
        //         }
        //     })
        //     .catch(function (error) {
        //         console.log(error);
        //     });
    }

    //base64图片文件
    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    //图片预览弹窗函数
    handlePreview = async file => {
        // console.log(file)
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };
    beforeUpload = (file) => {
        // console.log(file)
        // 控制上传图片格式
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            message.error('您只能上传JPG/PNG 文件!');
            return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('图片大小必须小于5MB!');
            return false;
        }
        return isJpgOrPng && isLt2M;
    }
    //上传文件改变时的状态，详情可以参考antd的Upload组件API参数
    onImgChange = ({fileList, file, event}) => {
        console.log(fileList[0])
        var imageHash = ''
        var imageUrl = ''
        if (fileList[0]) {
            let file = fileList[0];
            if (file.response) {
                let res = file.response;
                if (res.code === 0) {
                    let img = res.data
                    imageHash = img.imageHash
                    imageUrl = img.imageUrl
                    this.updateLogo(imageHash, imageUrl)
                }else {
                    message.error('图片格式有误',1,() => {
                        return;
                    })
                }
            }
        }
        this.setState({
            fileList: fileList,
            showImg: false,
        })

    };
    //图片预览取消函数
    handleCancel = () => this.setState({previewVisible: false});

    changeInputTelMain = e => {
        const {value} = e.target;
        console.log('订餐' + value)
        this.setState({inputTelMain: value})
    }
    changeInputTelIvrMain = e => {
        const {value} = e.target;
        console.log('提醒' + value)
        this.setState({inputTelIvrMain: value})
    }
    changeInputTelServiceMain = e => {
        const {value} = e.target;
        console.log('客服' + value)
        this.setState({inputTelServiceMain: value})
    }

    changeInputShopName = e => {
        const {value} = e.target;
        this.setState({inputShopName: value})
    }
    changeInputTel = e => {
        const {value} = e.target;
        this.setState({inputTel: value})
    }
    changeInputTelIvr = e => {
        const {value} = e.target;
        this.setState({inputTelIvr: value})
    }
    changeInputTelService = e => {
        const {value} = e.target;
        this.setState({inputTelService: value})
    }
    changeInputAddress = e => {
        const {value} = e.target;
        this.searchLatlngByAddress(value)
        this.setState({inputAddress: value})
    }
    changeInputShopNotice = e => {
        const {value} = e.target;
        this.setState({inputShopNotice: value})
    }
    changeInputShopDesc = e => {
        const {value} = e.target;
        this.setState({inputShopDesc: value})
    }
    changeInputInvoice = e => {
        const {value} = e.target;
        this.setState({inputInvoice: value})
    }

    onShowModalMap = (location) => {
        let locationArry = location.split(',');
        let long = locationArry[0];
        let lat = locationArry[1];
        console.log(lat)
        console.log(long)
        this.setState({
            onMapVisible: true,
            lat: lat,
            long: long
        })
    }
    onHandleOk = () => {
        this.updateAddress()
    }
    onHandleCancel = () => {
        this.setState({
            onMapVisible: false
        })
    }

    editShopContent = (type) =>{
        switch (type) {
            case '门店名称':
                this.updateName()
                break;
            case '订餐电话':
                this.updatePhone(this.state.inputTel, this.state.inputTelIvr, this.state.inputTelService)
                break;
            case '订单提醒电话':
                this.updatePhone(this.state.inputTel, this.state.inputTelIvr, this.state.inputTelService)
                break;
            case '客服电话':
                this.updatePhone(this.state.inputTel, this.state.inputTelIvr, this.state.inputTelService)
                break;
            case '门店公告':
                this.updateNotice()
                break;
            case '门店简介':
                this.updateDesc()
                break;
            case '发票':
                this.updateInvoice()
                break;
            default:
                break;
        }
    }

    updateName() {
        getShopUpdateName({
            content: this.state.inputShopName,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updatePhone(phone, ivrPhone, servicePhone) {
        getShopUpdatePhone({
            phone: phone,
            ivrPhone: ivrPhone,
            servicePhone: servicePhone,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updateAddress() {
        const _this = this;
        getShopUpdateAddress({
            address: this.state.inputAddress,
            geo: this.state.addressGeo,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    _this.setState({
                        onMapVisible: false
                    })
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    _this.setState({
                        onMapVisible: false
                    })
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updateOpenTime = (type)=> {
        let openTime = '';
        if (type === 1) {
            openTime = '00:00-23:59'
        } else {
            // openTime = '07:30-00:30'
            openTime = this.state.openTimeStart2 + '-' + this.state.openTimeEnd2
        }
        getShopUpdateOpentime({
            content: openTime,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updateNotice() {
        getShopUpdatePromotion({
            content: this.state.inputShopNotice,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updateDesc() {
        getShopUpdateDescription({
            content: this.state.inputShopDesc,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updateInvoice() {
        getShopUpdateInvoice({
            type: this.state.invoice,
            invoiceMinAmount: this.state.inputInvoice,
            shopId: this.state.shopId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    onChangeTimeinterval = e => {
        console.log('radio checked', e.target.value);
        this.setState({
            timeInterval: e.target.value,
        }, ()=>{
            // this.updateOpenTime(e.target.value)
        });
    };
    onChangeInvoice = e => {
        console.log('radio checked', e.target.value);
        this.setState({
            invoice: e.target.value,
        });
    };

    updateOpenTimeMain = (type)=> {
        let openTime = '';
        if (type === 1) {
            openTime = '00:00-23:59'
        } else {
            // openTime = '07:30-00:30'
            openTime = this.state.openTimeStart + '-' + this.state.openTimeEnd
        }

        getTemplateUpdateOpentime({
            content: openTime,
            templateId: this.state.templateId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    onChangeTimeintervalMain = e => {
        console.log('radio checked', e.target.value);
        this.setState({
            timeIntervalMain: e.target.value,
        }, ()=>{
            // this.updateOpenTimeMain(e.target.value)
        });
    };
    changeInputShopNoticeMain = e => {
        const {value} = e.target;
        this.setState({inputShopNoticeMain: value})
    }
    changeInputShopDescMain = e => {
        const {value} = e.target;
        this.setState({inputShopDescMain: value})
    }
    changeInputInvoiceMain = e => {
        const {value} = e.target;
        this.setState({inputInvoiceMain: value})
    }
    onChangeInvoiceMain = e => {
        console.log('radio checked', e.target.value);
        this.setState({
            invoiceMain: e.target.value,
        });
    };
    editShopContentMain = (type) =>{
        switch (type) {
            case '门店公告':
                this.updateNoticeMain()
                break;
            case '门店简介':
                this.updateDescMain()
                break;
            case '发票':
                this.updateInvoiceMain()
                break;
            case '订餐电话':
                this.updatePhoneMain(this.state.inputTelMain, this.state.inputTelIvrMain, this.state.inputTelServiceMain)
                break;
            case '订单提醒电话':
                this.updatePhoneMain(this.state.inputTelMain, this.state.inputTelIvrMain, this.state.inputTelServiceMain)
                break;
            case '客服电话':
                this.updatePhoneMain(this.state.inputTelMain, this.state.inputTelIvrMain, this.state.inputTelServiceMain)
                break;
            default:
                break;
        }
    }

    updatePhoneMain (phone, ivr_phone, service_phone) {
        getTemplateUpdatePhone({
            phone: phone,
            ivr_phone: ivr_phone,
            service_phone: service_phone,
            templateId: this.state.templateId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    updateNoticeMain() {
        getTemplateUpdatePromotion({
            content: this.state.inputShopNoticeMain,
            templateId: this.state.templateId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updateDescMain() {
        getTemplateUpdateDescription({
            content: this.state.inputShopDescMain,
            templateId: this.state.templateId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    updateInvoiceMain() {
        getTemplateUpdateInvoice({
            type: this.state.invoiceMain,
            invoiceMinAmount: this.state.inputInvoiceMain,
            templateId: this.state.templateId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success(data.msg)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    showAllModal = (msg) => {
        this.setState({
            showAllModal: true,
            // selectedRowKeysSync: [],
            syncMsg: msg
        })
    }
    onSelectChangeSync = selectedRowKeysSync => {
        console.log('selectedRowKeysSync changed: ', selectedRowKeysSync);
        this.setState({selectedRowKeysSync});
    };
    //确认同步
    toBranch = () => {
        const _this = this
        _this.setState({
            loadingAll: true
        }, () => {
            let type = 0;
            if (_this.state.syncMsg === '营业时间') {
                type = 1
            } else if (_this.state.syncMsg === '门店公告') {
                type = 2
            } else if (_this.state.syncMsg === '门店简介') {
                type = 3
            } else if (_this.state.syncMsg === '发票') {
                type = 4
            }

            getTemplateSynchronization({
                type: type,
                shops: _this.state.selectedRowKeysSync,
                templateId: _this.state.templateId
            }).then((res) => {
                if (res.status === 200) {
                    let data = res.data
                    if (data.code === 0) {
                        if (data.data.dataHandleStatus === 0) {
                            //建立websocket
                            _this.useWebSocketSync(data.data.messageKey)
                        } else {
                            setTimeout(() => {
                                _this.setState({
                                    // selectedRowKeysSync: [],
                                    loadingAll: false,
                                    showAllModal: false
                                });
                            }, 1000);
                        }
                    } else if (data.code === 50) {
                        message.error(data.msg)
                        removeToken();
                    } else {
                        message.error(data.msg)
                        _this.setState({loadingAll: false, showAllModal: false})
                    }
                }
            }).catch(error => {
                message.error(error.toString())
            })

            // axiosD.post(API_TEMPLATE_UPDATE_SYNC, {
            //     type: type,
            //     shops: _this.state.selectedRowKeysSync,
            //     templateId: _this.state.templateId
            // })
            //     .then(function (response) {
            //         let data = response.data;
            //         console.log(data);
            //         if (data.code === 0) {
            //             if (data.data.dataHandleStatus === 0) {
            //                 //建立websocket
            //                 _this.useWebSocketSync(data.data.messageKey)
            //             } else {
            //                 setTimeout(() => {
            //                     _this.setState({
            //                         // selectedRowKeysSync: [],
            //                         loadingAll: false,
            //                         showAllModal: false
            //                     });
            //                 }, 1000);
            //             }
            //         } else {
            //             message.error(data.msg)
            //             _this.setState({loadingAll: false, showAllModal: false})
            //         }
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
        })
    }
    cancelBranch = () => {
        this.setState({
            showAllModal: false
        })
    }

    useWebSocketSync(key) {
        let url = "wss://" + API_HOST_WEBSOCKET + "/websocket/message/" + key;//服务端连接的url
        this.createWebSocket(url)
        //在组件卸载的时候，关闭连接
        return () => {
            this.closeWebSocket();
        }
    }

    afterCloseModal = () => {
        this.setState({selectedRowKeysSync: []})
    }

    showSyncPhoneModal = (type) => {
        this.setState({
            showSyncPhoneModal: true,
            // selectedRowKeysSync: [],
            phoneType: type
        })
    }
    toBranchPhone = () => {
        const _this = this
        _this.setState({
            loadingAll2: true
        }, () => {
            getTemplateSynchronizationPhone({
                platformType: _this.state.platformType,
                shops: _this.state.selectedRowKeysSync,
                templateId: _this.state.templateId
            }).then((res) => {
                if (res.status === 200) {
                    let data = res.data
                    if (data.code === 0) {
                        if (data.data.dataHandleStatus === 0) {
                            //建立websocket
                            _this.useWebSocketSync(data.data.messageKey)
                        } else {
                            setTimeout(() => {
                                _this.setState({
                                    // selectedRowKeysSync: [],
                                    loadingAll2: false,
                                    showSyncPhoneModal: false
                                });
                            }, 1000);
                        }
                    } else if (data.code === 50) {
                        message.error(data.msg)
                        removeToken();
                    } else {
                        message.error(data.msg)
                        _this.setState({loadingAll2: false, showSyncPhoneModal: false})
                    }
                }
            }).catch(error => {
                message.error(error.toString())
            })
        })
    }
    cancelBranchPhone = () => {
        this.setState({
            showSyncPhoneModal: false
        })
    }

    renderBasic() {
        let {fileList, previewVisible, previewImage} = this.state
        //根据官方属性定制化裁剪框大小固定的裁剪组件属性
        const props = {
            width: 500,  //裁剪宽度
            height: 300, //裁剪高度
            resize: false, //裁剪是否可以调整大小
            resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
            modalTitle: "上传图片", //弹窗标题
            modalWidth: 600, //弹窗宽度
        };

        return (<div className="container-content-bg">

            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>门店头像</span>

                {this.state.showImg ? <img src={this.state.imageUrl} className='shop-img'/> : null}
                <ImgCrop {...props}>
                    <Upload
                        name="file"
                        action={API_IMG_UPLOAD}
                        accept="image/*"
                        listType="picture"
                        fileList={fileList}
                        beforeUpload={this.beforeUpload.bind(this)}
                        onPreview={this.handlePreview}
                        onChange={this.onImgChange}
                    >
                        {fileList.length >= 1 ? null : (<div className='img-container'>
                            <div>
                                <PlusOutlined style={{fontSize: "20px"}}/>
                                点击更换
                            </div>
                        </div>)}
                        {/* {通过三木运算符判断文件列表fileList的长度来决定上传图片的数量，达到控制图片数量的功能} */}
                    </Upload>
                </ImgCrop>
                {/* {图片预览弹出框：可以实时查看上传的图片} */}
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel} title='Image-Show'>
                    <img alt="example" style={{width: '100%'}} src={previewImage}/>
                </Modal>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>门店名称</span>
                <Input className="input" value={this.state.inputShopName} onChange={this.changeInputShopName} placeholder="请输入门店名称"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContent.bind(this, '门店名称')}>
                    确定修改
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>订餐电话</span>
                <Input className="input" value={this.state.inputTel} onChange={this.changeInputTel} placeholder="请输入订餐电话"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContent.bind(this, '订餐电话')}>
                    确定修改
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>订单提醒电话</span>
                <Input className="input" value={this.state.inputTelIvr} onChange={this.changeInputTelIvr} placeholder="请输入订单提醒电话"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContent.bind(this, '订单提醒电话')}>
                    确定修改
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>客服电话</span>
                <Input className="input" value={this.state.inputTelService} onChange={this.changeInputTelService} placeholder="请输入客服电话"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContent.bind(this, '客服电话')}>
                    确定修改
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>门店地址</span>
                <span style={{color: '#000000', fontSize: 16}} className="input">{this.state.inputAddress}</span>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.onShowModalMap.bind(this, this.state.addressGeo)}>
                    申请修改
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
        </div>)
    }

    onChangeS2(time, timeString) {
        console.log(time, timeString);
        this.setState({openTimeStart2: timeString})
    }
    onChangeE2(time, timeString) {
        console.log(time, timeString);
        this.setState({openTimeEnd2: timeString})
    }

    renderBusiness() {
        return (<div className="container-content-bg">
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>营业时间</span>
                <RadioGroup className="input" style={{width: '220px'}} onChange={this.onChangeTimeinterval} value={this.state.timeInterval}>
                    <Radio value={1}>24小时营业</Radio>
                    {/*<Radio value={2}>07:30-00:30(次日)</Radio>*/}
                    <Radio value={2}>自定义</Radio>
                </RadioGroup>
                <div style={{display: 'flex', flexDirection: 'row', marginTop: '5px'}}>
                    {
                        this.state.timeInterval == 1 ? <div style={{width: '290px'}} /> :
                            <ConfigProvider locale={zhCN}>
                                <div style={{display: "flex", flexDirection: "row", width: '290px'}}>
                                    <TimePicker
                                        value={this.state.openTimeStart2 == ''? '': moment(this.state.openTimeStart2, 'HH:mm')}
                                        format={'HH:mm'}
                                        style={{width: "120px"}}
                                        placeholder={'开始时间'}
                                        onChange={this.onChangeS2.bind(this)}
                                    />
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        height: "32px",
                                    }}>至
                                    </div>
                                    <TimePicker
                                        value={this.state.openTimeEnd2 == ''? '':moment(this.state.openTimeEnd2, 'HH:mm')}
                                        format={'HH:mm'}
                                        placeholder={'结束时间'}
                                        style={{width: "120px"}}
                                        onChange={this.onChangeE2.bind(this)}
                                    />
                                </div>
                            </ConfigProvider>
                    }
                    <Button type="primary" shape="round" onClick={this.updateOpenTime.bind(this, this.state.timeInterval)}>
                        确定修改
                    </Button>
                </div>
                {/*<Button type="primary" shape="round" onClick={this.updateOpenTime.bind(this, this.state.timeInterval)}>*/}
                {/*    确定修改*/}
                {/*</Button>*/}
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>门店公告</span>
                <Input.TextArea className="input" value={this.state.inputShopNotice} onChange={this.changeInputShopNotice} placeholder="请输入门店公告"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContent.bind(this, '门店公告')}>
                    确定修改
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>门店简介</span>
                <Input.TextArea className="input" value={this.state.inputShopDesc} onChange={this.changeInputShopDesc} placeholder="请输入门店简介"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContent.bind(this, '门店简介')}>
                    确定修改
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>发票</span>
                {/*<div className="container-contentC">*/}
                    <RadioGroup className="input" style={{width: '220px'}} onChange={this.onChangeInvoice} value={this.state.invoice}>
                        <Radio value={0}>不提供</Radio>
                        <Radio value={1}>提供</Radio>
                    </RadioGroup>
                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '5px'}}>
                        {
                            this.state.invoice === 0 ? <div style={{width: '290px'}} /> :
                                <Input style={{width: '290px'}} value={this.state.inputInvoice} onChange={this.changeInputInvoice} placeholder="请输入发票金额"/>
                        }
                        <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContent.bind(this, '发票')}>
                            确定修改
                        </Button>
                    </div>
                {/*</div>*/}
            </div>
        </div>)
    }

    onChangeS(time, timeString) {
        console.log(time, timeString);
        this.setState({openTimeStart: timeString})
    }
    onChangeE(time, timeString) {
        console.log(time, timeString);
        this.setState({openTimeEnd: timeString})
    }

    renderBasicMain() {
        return (<div className="container-content-bg">
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>营业时间</span>
                <RadioGroup className="input" style={{width: '220px'}} onChange={this.onChangeTimeintervalMain} value={this.state.timeIntervalMain}>
                    <Radio value={1}>24小时营业</Radio>
                    <Radio value={2}>自定义</Radio>
                </RadioGroup>

                <div style={{display: 'flex', flexDirection: 'row', marginTop: '5px'}}>
                    {
                        this.state.timeIntervalMain == 1 ? <div style={{width: '290px'}} /> :
                            <ConfigProvider locale={zhCN}>
                            <div style={{display: "flex", flexDirection: "row", width: '290px'}}>
                                <TimePicker
                                    value={this.state.openTimeStart == ''? '': moment(this.state.openTimeStart, 'HH:mm')}
                                    format={'HH:mm'}
                                    style={{width: "120px"}}
                                    placeholder={'开始时间'}
                                    onChange={this.onChangeS.bind(this)}
                                />
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                    height: "32px",
                                }}>至
                                </div>
                                <TimePicker
                                    value={this.state.openTimeEnd == ''? '':moment(this.state.openTimeEnd, 'HH:mm')}
                                    format={'HH:mm'}
                                    placeholder={'结束时间'}
                                    style={{width: "120px"}}
                                    onChange={this.onChangeE.bind(this)}
                                />
                            </div>
                            </ConfigProvider>
                    }
                    <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.updateOpenTimeMain.bind(this, this.state.timeIntervalMain)}>
                        确定修改
                    </Button>
                    <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showAllModal.bind(this, '营业时间')}>
                        同步
                    </Button>
                </div>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>订餐电话</span>
                <Input className="input" value={this.state.inputTelMain} onChange={this.changeInputTelMain} placeholder="请输入订餐电话"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContentMain.bind(this, '订餐电话')}>
                    确定修改
                </Button>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showSyncPhoneModal.bind(this, 1)}>
                    同步
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>订单提醒电话</span>
                <Input className="input" value={this.state.inputTelIvrMain} onChange={this.changeInputTelIvrMain} placeholder="请输入订单提醒电话"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContentMain.bind(this, '订单提醒电话')}>
                    确定修改
                </Button>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showSyncPhoneModal.bind(this, 2)}>
                    同步
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>客服电话</span>
                <Input className="input" value={this.state.inputTelServiceMain} onChange={this.changeInputTelServiceMain} placeholder="请输入客服电话"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContentMain.bind(this, '客服电话')}>
                    确定修改
                </Button>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showSyncPhoneModal.bind(this, 3)}>
                    同步
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>门店公告</span>
                <Input.TextArea className="input" value={this.state.inputShopNoticeMain} onChange={this.changeInputShopNoticeMain} placeholder="请输入门店公告"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContentMain.bind(this, '门店公告')}>
                    确定修改
                </Button>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showAllModal.bind(this, '门店公告')}>
                    同步
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>门店简介</span>
                <Input.TextArea className="input" value={this.state.inputShopDescMain} onChange={this.changeInputShopDescMain} placeholder="请输入门店简介"/>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContentMain.bind(this, '门店简介')}>
                    确定修改
                </Button>
                <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showAllModal.bind(this, '门店简介')}>
                    同步
                </Button>
            </div>
            <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
            <div className="container-content">
                <span style={{color: '#000000', fontSize: 16, width: '100px'}}>发票</span>
                <RadioGroup className="input" style={{width: '220px'}} onChange={this.onChangeInvoiceMain} value={this.state.invoiceMain}>
                    <Radio value={0}>不提供</Radio>
                    <Radio value={1}>提供</Radio>
                </RadioGroup>
                <div style={{display: 'flex', flexDirection: 'row', marginTop: '5px'}}>
                    {
                        this.state.invoiceMain === 0 ? <div style={{width: '290px'}} /> :
                            <Input style={{width: '290px'}} value={this.state.inputInvoiceMain} onChange={this.changeInputInvoiceMain} placeholder="请输入发票金额"/>
                    }
                    <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.editShopContentMain.bind(this, '发票')}>
                        确定修改
                    </Button>
                    <Button style={{marginLeft: '10px'}} shape="round" type="primary" onClick={this.showAllModal.bind(this, '发票')}>
                        同步
                    </Button>
                </div>
            </div>
        </div>)
    }

    markersEvents = {
        created:(allMarkers) => {
            console.log('All Markers Instance Are Below');
            console.log(allMarkers);
        },
        click: (MapsOption, marker) => {
            console.log('MapsOptions:');
            console.log(MapsOption);
            console.log('marker:');
            console.log(marker);
        },
        dragend: (MapsOption, marker) => {
            console.log('markerdragendlatlng:');
            console.log(MapsOption.lnglat.lng);
            console.log(MapsOption.lnglat.lat);
            this.setState({
                addressGeo: MapsOption.lnglat.lng + ',' + MapsOption.lnglat.lat,
                long: MapsOption.lnglat.lng,
                lat: MapsOption.lnglat.lat
            }, () =>{
                this.searchAddressBylatlng(MapsOption.lnglat.lng, MapsOption.lnglat.lat)
            })
        }
    }

    searchAddressBylatlng(lng, lat) {
        const _this = this;
        let key = 'e73ee0f829ee336137ca9eabdee6382e';
        axiosD.get('https://restapi.amap.com/v3/geocode/regeo?key='
            + key + '&location=' + lng +',' +lat, {
        })
            .then(function (response) {
                console.log(response.data)
                let code = response.data.status;
                if (code == '1') {
                    _this.setState({
                        inputAddress: response.data.regeocode.formatted_address,
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {
        const {shop, selectedRowKeysSync} = this.state
        const rowSelectionSync = {
            selectedRowKeysSync,
            onChange: this.onSelectChangeSync,
        };
        const columnsSyncShop = [
            {
                title: '店',
                dataIndex: 'branchShopName',
            },
        ];
        return (
            <div style={{width: "100%"}}>
                <Row className="container">
                    <Col span="24" className="container-main">
                        <div className="container-msg">
                            <div className="container-top">
                                {/*<Select defaultValue="全部"*/}
                                {/*        style={{width: 220, marginRight: 50}}*/}
                                {/*        bordered={true}*/}
                                {/*        onChange={this.changeShop}>*/}
                                {/*    <Option value={0}>{'全部'}</Option>*/}
                                {/*    {this.state.shop && this.state.shop.map((item) => {*/}
                                {/*        return <Option key={item.branchShopId} value={item.branchShopId}>{item.branchShopName}</Option>*/}
                                {/*    })}*/}
                                {/*</Select>*/}
                            </div>
                            {
                                this.state.shopId == 0 ?
                                    <Tabs defaultActiveKey={'0'}>
                                        <TabPane tab="模板信息" key="0">
                                            {this.renderBasicMain()}
                                        </TabPane>
                                    </Tabs>
                                    :
                                    <Tabs defaultActiveKey={'0'} onChange={this.callback.bind(this)}>
                                        <TabPane tab="基本信息" key="0">
                                            {this.renderBasic()}
                                        </TabPane>
                                        <TabPane tab="营业信息" key="1">
                                            {this.renderBusiness()}
                                        </TabPane>
                                    </Tabs>
                            }
                            {/*<Tabs defaultActiveKey={'0'} onChange={this.callback.bind(this)}>*/}
                            {/*    <TabPane tab="基本信息" key="0">*/}
                            {/*        {*/}
                            {/*            this.state.shopId == 0 ? null : this.renderBasic()*/}
                            {/*        }*/}
                            {/*    </TabPane>*/}
                            {/*    <TabPane tab="营业信息" key="1">*/}
                            {/*        {*/}
                            {/*            this.state.shopId == 0 ? null : this.renderBusiness()*/}
                            {/*        }*/}
                            {/*    </TabPane>*/}
                            {/*</Tabs>*/}
                        </div>
                    </Col>
                </Row>

                <Modal
                    title="修改地址"
                    width={'70%'}
                    visible={this.state.onMapVisible}
                    onOk={this.onHandleOk.bind(this)}
                    onCancel={this.onHandleCancel.bind(this)}
                    okText="确认"
                    cancelText="取消"
                >
                    <Input value={this.state.inputAddress} onChange={this.changeInputAddress} placeholder="请输入门店地址"/>
                    <div style={{width: '100%', height: '600px'}}>
                        <Map zoom={15} amapkey={'e73ee0f829ee336137ca9eabdee6382e'}
                             center={{longitude: this.state.long, latitude: this.state.lat}}>
                            <Marker icon={'/assets/user_location.png'}
                                    draggable={true}
                                    events={this.markersEvents}
                                    position={{longitude: this.state.long, latitude: this.state.lat}}/>
                        </Map>
                    </div>
                </Modal>

                <Modal
                    title="同步至分店"
                    width={'60%'}
                    visible={this.state.showAllModal}
                    onOk={this.toBranch.bind(this)}
                    onCancel={this.cancelBranch.bind(this)}
                    confirmLoading={this.state.loadingAll}
                    afterClose={this.afterCloseModal.bind(this)}
                    destroyOnClose={true}
                    okText="确认"
                    cancelText="取消"
                >
                    <div style={{width: '100%', height: '600px'}}>
                        <Table rowKey="branchShopId"
                               rowSelection={rowSelectionSync}
                               columns={columnsSyncShop}
                               pagination = {false}
                               scroll = {{y:'550px'}}
                               dataSource={shop}/>
                    </div>
                </Modal>

                <Modal
                    title="同步至分店"
                    width={'60%'}
                    visible={this.state.showSyncPhoneModal}
                    onOk={this.toBranchPhone.bind(this)}
                    onCancel={this.cancelBranchPhone.bind(this)}
                    confirmLoading={this.state.loadingAll2}
                    afterClose={this.afterCloseModal.bind(this)}
                    destroyOnClose={true}
                    okText="确认"
                    cancelText="取消"
                >
                    <div style={{width: '100%', height: '600px'}}>
                        <Table rowKey="branchShopId"
                               rowSelection={rowSelectionSync}
                               columns={columnsSyncShop}
                               pagination = {false}
                               scroll = {{y:'550px'}}
                               dataSource={shop}/>
                    </div>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/shopmanage/shopmessage/index.js